// Robustesse des mots de passe, d'après la recommandation de la CNIL (délibération 2022-100) :
// pour un mot de passe utilisé seul, viser l'équivalent de 80 bits, par exemple
//  - 12 caractères au moins, avec majuscules, minuscules, chiffres et caractères spéciaux ;
//  - ou 14 caractères au moins, avec majuscules, minuscules et chiffres.

export const PASSWORD_RULES = [
  { id: 'length',  label: '12 caractères minimum',  test: (p) => p.length >= 12 },
  { id: 'lower',   label: 'Une minuscule',          test: (p) => /[a-zà-ÿ]/.test(p) },
  { id: 'upper',   label: 'Une majuscule',          test: (p) => /[A-ZÀ-Þ]/.test(p) },
  { id: 'digit',   label: 'Un chiffre',             test: (p) => /\d/.test(p) },
  { id: 'special', label: 'Un caractère spécial (ou 14 caractères)', test: (p) => /[^A-Za-zÀ-ÿ0-9]/.test(p) || p.length >= 14 },
];

const COMMON = ['password', 'motdepasse', 'azerty', 'qwerty', '123456', 'nowatt', 'soleil', 'bonjour'];

// Niveau de 0 à 4 et validité (true quand la recommandation CNIL est respectée)
export function passwordStrength(p = '') {
  if (!p) return { level: 0, valid: false, checks: PASSWORD_RULES.map((r) => ({ ...r, ok: false })) };
  const checks = PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(p) }));
  const lowered = p.toLowerCase();
  const common = COMMON.some((w) => lowered.includes(w));
  const passed = checks.filter((c) => c.ok).length;
  const valid = passed === checks.length && !common;
  let level = passed <= 2 ? 1 : passed <= 4 ? 2 : 3;
  if (valid && p.length >= 16) level = 4;
  if (common) level = Math.min(level, 1);
  return { level, valid, common, checks };
}

export const STRENGTH_LABELS = ['', 'Faible', 'Moyen', 'Bon', 'Excellent'];
